import React,{useState} from 'react';
import {Dialog,DialogContent,DialogTitle,DialogActions,Button,Divider} from "@material-ui/core";
import Input from '../../Utils/Input';
import realtimeDB, { db } from '../../Utils/api';

const AddCategoriaModal = ({open,close}) => 
{
    const [Nombre, setNombre] = useState("");
    const [Indice, setIndice] = useState("")

    
    let buttonDisabled=Nombre==="" || Indice==="" || Number(Indice) <= 0;
    const crearCategoria=async()=>
    {
        await realtimeDB.ref("/Menu/CategoriasDOS").child(Nombre).set({Nombre,Indice});
        setNombre("");
        setIndice("");
        close();
    }


    return <Dialog open={open} onClose={close}>
        <DialogTitle style={{textAlign:"center"}}>Agregar categoría</DialogTitle>
        <DialogContent>
           <Input label="Nombre" value={Nombre} changeValue={setNombre}/>
           <Input type="number" label="Posición" value={Indice} changeValue={setIndice}/>
        </DialogContent>
        <DialogActions>
        <Button color="primary" variant="outlined" onClick={close}>Cancelar</Button>
         <Button color="primary" variant="contained" onClick={crearCategoria} disabled={buttonDisabled}>Crear</Button>
        </DialogActions>
    </Dialog>
}

export default AddCategoriaModal
